import { ToggleButton, ToggleButtonGroup, Tooltip, alpha } from "@mui/material";
import { useTranslation } from "react-i18next";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import PaletteOutlinedIcon from "@mui/icons-material/PaletteOutlined";
import ContrastOutlinedIcon from "@mui/icons-material/ContrastOutlined";
import { EslPreviewMode, useEslPreviewMode } from "./EslPreviewModeContext";

const EslPreviewModeToggle = () => {
    const { t } = useTranslation(["eslTemplate"]);
    const { mode, setMode } = useEslPreviewMode();

    const handleChange = (_event: React.MouseEvent<HTMLElement>, nextMode: EslPreviewMode | null) => {
        if (nextMode === null) return;

        setMode(nextMode);
    };

    return (
        <ToggleButtonGroup
            exclusive
            value={mode}
            onChange={handleChange}
            size="small"
            sx={{
                "& .MuiToggleButton-root.Mui-selected": {
                    backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.12),
                    color: "primary.main",
                    "&:hover": {
                        backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.18),
                    },
                },
            }}
        >
            <Tooltip title={t("eslTemplate:templateEditor.previewMode.designHint")}>
                <ToggleButton value="design">
                    <EditOutlinedIcon fontSize="small" sx={{ mr: 0.75 }} />
                    {t("eslTemplate:templateEditor.previewMode.design")}
                </ToggleButton>
            </Tooltip>
            <Tooltip title={t("eslTemplate:templateEditor.previewMode.colorScreenHint")}>
                <ToggleButton value="colorScreen">
                    <PaletteOutlinedIcon fontSize="small" sx={{ mr: 0.75 }} />
                    {t("eslTemplate:templateEditor.previewMode.colorScreen")}
                </ToggleButton>
            </Tooltip>
            <Tooltip title={t("eslTemplate:templateEditor.previewMode.redAndBlackScreenHint")}>
                <ToggleButton value="redAndBlackScreen">
                    <ContrastOutlinedIcon fontSize="small" sx={{ mr: 0.75 }} />
                    {t("eslTemplate:templateEditor.previewMode.redAndBlackScreen")}
                </ToggleButton>
            </Tooltip>
        </ToggleButtonGroup>
    );
};

export default EslPreviewModeToggle;
